import React from "react";
import { CheckMailCode } from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/useValidationSchemaMailCode";
import { checkCodeMail } from "src/app/api/FinalizationApi";
import AppCol from "src/commun/composants/grille/AppCol";
import AppRow from "src/commun/composants/grille/AppRow";
import { useAppText } from "src/commun/composants/AppText";
import CodeMailCheckForm from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/CodeMailCheckForm";
import { useAppState } from "src/app/state/StateProvider";

export type VerificationMailContainerProps = {
  initialValues: CheckMailCode;
  stepSuivante: () => void;
  stepPrecedente: () => void;
};

const CodeMailCheckContainer = ({ initialValues, stepSuivante, stepPrecedente }: VerificationMailContainerProps) => {
  const { tString } = useAppText();
  const [{ configuration }] = useAppState();
  const submitSuccessHandler = () => {
    stepSuivante();
  };

  const submitFormAPI = (values: CheckMailCode) => checkCodeMail(values);

  return (
    <AppRow>
      <AppCol md={7}>
        <label>{tString("compte.saisie.email.message", [configuration?.codeDelaiValidite])}</label>
      </AppCol>
      <AppCol md={5}>
        <CodeMailCheckForm
          initialValues={initialValues}
          stepPrecedente={stepPrecedente}
          submitSuccessHandler={submitSuccessHandler}
          submitFormAPI={submitFormAPI} />
      </AppCol>
    </AppRow>

  );
};

export default CodeMailCheckContainer;